import { useQuery } from '@tanstack/react-query'

import { ordersService } from './orders-service'

/** One order by autoid, on the `['order', autoid]` key the packing views share. */
export const useOrder = (autoid: string | null | undefined, enabled = true) =>
  useQuery({
    queryKey: ['order', autoid],
    queryFn: async () => ordersService.getByAutoId(autoid!),
    enabled: enabled && !!autoid
  })
